import TextBubble from 'components/TextBubble';
import {
	get, isEmpty, noop
} from 'lodash';
import React from 'react';

export function getTotalSavings(items) {
	if (!items.length) {
		return 0;
	}

	return items.reduce((prev, curr) => {
		const { autorefill } = curr;
		if (!isEmpty(autorefill) && autorefill.selected) {
			return prev + autorefill.discount_cents;
		}
		return prev;
	},
	0);
}

export function handleDoctorFeeDisclaimer(state, rxCredit) {
	const tag = get(state,
			'patient.tag'),
		campaigns = get(state,
			'patient.acquisitionCampaigns'),
		visitFee = get(state,
			'cart.visitFeeCents'),
		prescriptionCredit = get(state,
			'cart.promos.PRESCRIPTION_CREDIT'),
		appliedRxCredit = get(state,
			'cart.rxCredit');

	if (!prescriptionCredit && visitFee && visitFee > 0) {
		if (rxCredit) {
			return (
				<TextBubble>
            Great news! You've got ${rxCredit} in credit towards your
            prescription.
				</TextBubble>
			);
		}
		if (appliedRxCredit) {
			return (
				<TextBubble>
            Great news! You've got ${appliedRxCredit} in credit towards your
            prescription.
				</TextBubble>
			);
		}
		if (tag && tag === 'SHOP' && campaigns && campaigns[0]) {
			const campaign = campaigns[0].toLowerCase().split('_').join(' ');
			return (
				<TextBubble>
            Your ${visitFee / 100} visit fee will get you an evaluation for{' '}
					<span style={{ textTransform: 'capitalize' }}>{campaign}</span>.
				</TextBubble>
			);
		} else {
			return null;
		}
	} else if (rxCredit) {
		return (
			<TextBubble>
        Great news! You've got ${rxCredit} in credit towards your prescription.
			</TextBubble>
		);
	} else if (appliedRxCredit) {
		return (
			<TextBubble>
        Great news! You've got ${appliedRxCredit} in credit towards your
        prescription.
			</TextBubble>
		);
	}
	return null;
}

export function formatLineItems (lineItems, medCheckout) {
	let newLineItems = [];
	let productTotal = 0;
	let realCost;

	lineItems.forEach((item) => {
		if (item.type === 'product') {
			productTotal += 1;
			if (!medCheckout) {
				newLineItems.push(item);
			}
		} else if (item.description === 'Prescription credit' && !medCheckout) {
			newLineItems.push(item);
		} else {
			if (item.type === 'total') {
				realCost = item.realCost;
			}
			if (item.type === 'prescription_savings' && medCheckout) {
				newLineItems.push(item);
			} else if (item.type !== 'prescription_savings') {
				newLineItems.push(item);
			}
		}
	});

	if (medCheckout) {
		newLineItems.unshift({
			type: 'product_summary',
			description: `Product Total (${productTotal})`,
			cost: realCost,
			deleteable: false,
		});
	}
	return newLineItems;
}


export function formatCadenceCheckoutLineItems (lineItems, medCheckout) {
	let newLineItems = [];
	let productTotal = 0;
	let realCost;

	lineItems.forEach((item) => {
		if (item.type === 'product') {
			productTotal += 1;
			newLineItems.push(item);
		} else if (item.description === 'Prescription credit' && !medCheckout) {
			newLineItems.push(item);
		} else {
			if (item.type === 'total') {
				realCost = item.realCost;
			}
			if (item.type === 'prescription_savings' && medCheckout) {
				newLineItems.push(item);
			} else if (item.type === 'buy_more_savings') {
				noop()
			} else if (item.type !== 'prescription_savings') {
				newLineItems.push(item);
			}
		}
	});

	// if (medCheckout) {
	// 	newLineItems.unshift({
	// 		type: 'product_summary',
	// 		description: `Product Total AHHHHHHHHHHHHHHH ! (${productTotal})`,
	// 		cost: realCost,
	// 		deleteable: false,
	// 	});
	// }
	console.log('formatCadenceCheckoutLineItems : ',
		newLineItems)
	return newLineItems;
}
